import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './en-US'
import zhLocale from './zh-CN'
import elementEnLocale from 'element-ui/lib/locale/lang/en.js'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN.js'
import store from '@/store/index'
import { getStorageLang, getBrowserlang } from '@/common/storage'
Vue.use(VueI18n)

let en = { ...enLocale, ...elementEnLocale }
let zh = { ...zhLocale,...elementZhLocale }



const messages = {
    'en-US': en,
    'zh-CN': zh
}

export function getLanguage() {
    const lang = getStorageLang() || <string>store.state.app.locale || getBrowserlang();
    return lang
}

const i18n = new VueI18n({
    locale: getLanguage(),
    messages
})

export default i18n
